import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Prop, Ref } from 'vue-property-decorator';
import { QBtn, QDate, QIcon, QInput, QSelect } from 'quasar';
import dayjs from 'dayjs';
import store from '../../../store';
import useNotification from '../../../utils/Notification';
import { createAPIKey } from '../../../utils/serviceProxy';
import useValidation from '../../../utils/Validation';
import BaseControl from './BaseControl';
import { EMAIL_REGEX } from '../../../helpers';
var inputMapping = {
    email: 'email',
    password: 'password',
    text: 'text',
    textarea: 'textarea'
};
function hasInputMapping(inputType) {
    return Object.prototype.hasOwnProperty.call(inputMapping, inputType);
}
var TextControl = /** @class */ (function (_super) {
    __extends(TextControl, _super);
    function TextControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.validCode = null;
        _this.success = false;
        _this.failure = false;
        _this.serviceFailure = false;
        _this.failureCountryCode = false;
        _this.countInputs = 1;
        _this.inputValue = '';
        _this.inputValue1 = '';
        _this.inputValue2 = '';
        _this.inputValue3 = '';
        _this.inputValue4 = '';
        _this.inputValue5 = '';
        _this.inputValue6 = '';
        _this.inputValue7 = '';
        _this.inputValue8 = '';
        _this.inputValue9 = '';
        _this.inputValue10 = '';
        _this.inputValue11 = '';
        _this.inputValue12 = '';
        _this.inputValue13 = '';
        _this.inputValue14 = '';
        _this.inputValue15 = '';
        _this.inputValue16 = '';
        _this.inputValue17 = '';
        _this.inputValue18 = '';
        _this.inputValue19 = '';
        _this.inputValue20 = '';
        _this.showDate = false;
        _this.showEingabeValidCode = false;
        return _this;
    }
    TextControl.prototype.mounted = function () {
        var _a;
        if (this.multiInput) {
            var inputList = (_a = this.controlProps.value) === null || _a === void 0 ? void 0 : _a.toString().split(',');
            if (inputList) {
                this.countInputs = inputList.length;
                // eslint-disable-next-line prefer-destructuring
                if (inputList[0])
                    this.inputValue1 = inputList[0];
                // eslint-disable-next-line prefer-destructuring
                if (inputList[1])
                    this.inputValue2 = inputList[1];
                // eslint-disable-next-line prefer-destructuring
                if (inputList[2])
                    this.inputValue3 = inputList[2];
                // eslint-disable-next-line prefer-destructuring
                if (inputList[3])
                    this.inputValue4 = inputList[3];
                // eslint-disable-next-line prefer-destructuring
                if (inputList[4])
                    this.inputValue5 = inputList[4];
                // eslint-disable-next-line prefer-destructuring
                if (inputList[5])
                    this.inputValue6 = inputList[5];
                // eslint-disable-next-line prefer-destructuring
                if (inputList[6])
                    this.inputValue7 = inputList[6];
                // eslint-disable-next-line prefer-destructuring
                if (inputList[7])
                    this.inputValue7 = inputList[7];
                // eslint-disable-next-line prefer-destructuring
                if (inputList[8])
                    this.inputValue8 = inputList[8];
                // eslint-disable-next-line prefer-destructuring
                if (inputList[9])
                    this.inputValue9 = inputList[9];
                // eslint-disable-next-line prefer-destructuring
                if (inputList[10])
                    this.inputValue9 = inputList[10];
                // eslint-disable-next-line prefer-destructuring
                if (inputList[11])
                    this.inputValue9 = inputList[11];
                // eslint-disable-next-line prefer-destructuring
                if (inputList[12])
                    this.inputValue9 = inputList[12];
                // eslint-disable-next-line prefer-destructuring
                if (inputList[13])
                    this.inputValue9 = inputList[13];
                // eslint-disable-next-line prefer-destructuring
                if (inputList[14])
                    this.inputValue9 = inputList[14];
                // eslint-disable-next-line prefer-destructuring
                if (inputList[15])
                    this.inputValue9 = inputList[15];
                // eslint-disable-next-line prefer-destructuring
                if (inputList[16])
                    this.inputValue9 = inputList[16];
                // eslint-disable-next-line prefer-destructuring
                if (inputList[17])
                    this.inputValue9 = inputList[17];
                // eslint-disable-next-line prefer-destructuring
                if (inputList[18])
                    this.inputValue9 = inputList[18];
                // eslint-disable-next-line prefer-destructuring
                if (inputList[19])
                    this.inputValue9 = inputList[19];
                // eslint-disable-next-line prefer-destructuring
                if (inputList[20])
                    this.inputValue9 = inputList[20];
            }
        }
    };
    TextControl.prototype.optionsAmount = function (maxAnzahl) {
        var allOptions = [{ label: '1', value: 1 }];
        // eslint-disable-next-line no-plusplus
        for (var i = 2; i <= maxAnzahl; i++) {
            allOptions.push({ label: "" + i, value: i });
        }
        return allOptions;
    };
    TextControl.prototype.prepareEmit = function (value) {
        this.emitInput(value.trim());
    };
    TextControl.prototype.prepareEmitValid = function (value) {
        this.validCode = value;
    };
    TextControl.prototype.resetValid = function () {
        // console.log('reset');
        store.states.isMobileNumberValid = false;
        this.showEingabeValidCode = false;
    };
    TextControl.prototype.resetEMailValid = function () {
        // console.log('reset');
        store.states.isEMailValid = false;
        this.showEingabeValidCode = false;
    };
    TextControl.prototype.isEmailFormatValid = function () {
        var _a;
        return EMAIL_REGEX.test(((_a = this.value) === null || _a === void 0 ? void 0 : _a.toString()) || 's');
    };
    TextControl.prototype.isAlredyValid = function () {
        return store.states.isMobileNumberValid === true;
    };
    TextControl.prototype.isAlredyEMailValid = function () {
        return store.states.isEMailValid === true;
    };
    TextControl.prototype.sendValidSMSCode = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        return __awaiter(this, void 0, void 0, function () {
            var phoneCheck, smsCheck;
            return __generator(this, function (_q) {
                switch (_q.label) {
                    case 0: return [4 /*yield*/, this.makePhoneNumberValidation(this.value)];
                    case 1:
                        phoneCheck = _q.sent();
                        this.failureCountryCode = false;
                        this.failure = false;
                        if (!((phoneCheck === null || phoneCheck === void 0 ? void 0 : phoneCheck.data.data.data.isValid) && (phoneCheck === null || phoneCheck === void 0 ? void 0 : phoneCheck.data.data.data.isMobileNumber) === true)) return [3 /*break*/, 5];
                        if (!!((_c = (_b = (_a = phoneCheck === null || phoneCheck === void 0 ? void 0 : phoneCheck.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.countryCode.includes('DE'))) return [3 /*break*/, 2];
                        this.failure = true;
                        this.failureCountryCode = true;
                        return [3 /*break*/, 4];
                    case 2:
                        if (phoneCheck === null || phoneCheck === void 0 ? void 0 : phoneCheck.data.data.data.phoneNumber.includes(phoneCheck === null || phoneCheck === void 0 ? void 0 : phoneCheck.data.data.data.phoneCountryPrefix)) {
                            this.value = phoneCheck === null || phoneCheck === void 0 ? void 0 : phoneCheck.data.data.data.phoneNumber.slice(0).replaceAll(' ', '');
                        }
                        else {
                            this.value = phoneCheck === null || phoneCheck === void 0 ? void 0 : phoneCheck.data.data.data.phoneCountryPrefix.slice(0).concat(phoneCheck === null || phoneCheck === void 0 ? void 0 : phoneCheck.data.data.data.phoneNumber.slice(1)).replace(' ', '');
                        }
                        return [4 /*yield*/, this.makeSendSMS(this.value)];
                    case 3:
                        smsCheck = _q.sent();
                        if (smsCheck) {
                            if (((_g = (_f = (_e = (_d = smsCheck === null || smsCheck === void 0 ? void 0 : smsCheck.data) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.remainingCredits) <= 1)
                                console.error('SMS Kontingent erreicht');
                            if (((_k = (_j = (_h = smsCheck === null || smsCheck === void 0 ? void 0 : smsCheck.data) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.success) === true) {
                                this.showEingabeValidCode = true;
                            }
                            else {
                                console.log('fffehler');
                                this.serviceFailure = true;
                                store.states.isMobileNumberValid = true;
                            }
                        }
                        else {
                            this.failure = true;
                        }
                        _q.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        if ((phoneCheck === null || phoneCheck === void 0 ? void 0 : phoneCheck.data.data.data.isValidCountryPrefix) && !((_p = (_o = (_m = (_l = phoneCheck === null || phoneCheck === void 0 ? void 0 : phoneCheck.data) === null || _l === void 0 ? void 0 : _l.data) === null || _m === void 0 ? void 0 : _m.data) === null || _o === void 0 ? void 0 : _o.countryCode) === null || _p === void 0 ? void 0 : _p.includes('DE'))) {
                            this.failure = true;
                            this.failureCountryCode = true;
                        }
                        else {
                            this.failure = true;
                        }
                        _q.label = 6;
                    case 6: return [2 /*return*/, phoneCheck === null || phoneCheck === void 0 ? void 0 : phoneCheck.data.data.data.isValid];
                }
            });
        });
    };
    TextControl.prototype.sendValidEMailCode = function () {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var mailCheck;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        this.failure = false;
                        if (!EMAIL_REGEX.test(((_a = this.value) === null || _a === void 0 ? void 0 : _a.toString()) || '')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.makeSendEMail(this.value)];
                    case 1:
                        mailCheck = _e.sent();
                        if (mailCheck) {
                            if (((_d = (_c = (_b = mailCheck === null || mailCheck === void 0 ? void 0 : mailCheck.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.success) === true) {
                                this.showEingabeValidCode = true;
                            }
                            else {
                                this.failure = true;
                            }
                        }
                        else {
                            this.failure = true;
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        this.failure = true;
                        _e.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // prüft die eingebene Mobilnummer auf korrektheit
    TextControl.prototype.makePhoneNumberValidation = function (value) {
        return __awaiter(this, void 0, Promise, function () {
            var apikey, checkPhoneNumber, phoneCheck, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAPIKey()];
                    case 1:
                        apikey = _a.sent();
                        checkPhoneNumber = useValidation({ apikey: apikey }).checkPhoneNumber;
                        phoneCheck = null;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, , 6]);
                        if (!value) return [3 /*break*/, 4];
                        return [4 /*yield*/, checkPhoneNumber(value)];
                    case 3:
                        phoneCheck = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (phoneCheck)
                            return [2 /*return*/, phoneCheck];
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        console.log(e_1);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/, null];
                }
            });
        });
    };
    TextControl.prototype.makeSendEMail = function (value) {
        return __awaiter(this, void 0, Promise, function () {
            var apikey, sendValidEMail, mailCheck, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAPIKey()];
                    case 1:
                        apikey = _a.sent();
                        sendValidEMail = useNotification({ apikey: apikey }).sendValidEMail;
                        mailCheck = null;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, , 6]);
                        if (!value) return [3 /*break*/, 4];
                        return [4 /*yield*/, sendValidEMail(value)];
                    case 3:
                        mailCheck = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (mailCheck)
                            return [2 /*return*/, mailCheck];
                        return [3 /*break*/, 6];
                    case 5:
                        e_2 = _a.sent();
                        console.log(e_2);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/, null];
                }
            });
        });
    };
    // sendet eine SMS
    TextControl.prototype.makeSendSMS = function (value) {
        return __awaiter(this, void 0, Promise, function () {
            var apikey, sendValidSMS, phoneCheck, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAPIKey()];
                    case 1:
                        apikey = _a.sent();
                        sendValidSMS = useNotification({ apikey: apikey }).sendValidSMS;
                        phoneCheck = null;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, , 6]);
                        if (!value) return [3 /*break*/, 4];
                        return [4 /*yield*/, sendValidSMS(value)];
                    case 3:
                        phoneCheck = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (phoneCheck)
                            return [2 /*return*/, phoneCheck];
                        return [3 /*break*/, 6];
                    case 5:
                        e_3 = _a.sent();
                        console.log(e_3);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/, null];
                }
            });
        });
    };
    TextControl.prototype.checkValidEMailCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var check;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.failure = false;
                        return [4 /*yield*/, this.makeSMSValidation(this.validCode, this.value)];
                    case 1:
                        check = _a.sent();
                        this.success = check === null || check === void 0 ? void 0 : check.data.data;
                        if (this.success) {
                            this.showEingabeValidCode = false;
                            store.states.isEMailValid = true;
                            this.failure = false;
                        }
                        else {
                            store.states.isEMailValid = false;
                            this.failure = true;
                        }
                        console.log('Test', check === null || check === void 0 ? void 0 : check.data);
                        return [2 /*return*/];
                }
            });
        });
    };
    TextControl.prototype.checkValidCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var check;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.failure = false;
                        return [4 /*yield*/, this.makeSMSValidation(this.validCode, this.value)];
                    case 1:
                        check = _a.sent();
                        this.success = check === null || check === void 0 ? void 0 : check.data.data;
                        if (this.success) {
                            this.showEingabeValidCode = false;
                            store.states.isMobileNumberValid = true;
                            this.failure = false;
                        }
                        else {
                            store.states.isMobileNumberValid = false;
                            this.failure = true;
                        }
                        console.log('Test', check === null || check === void 0 ? void 0 : check.data);
                        return [2 /*return*/];
                }
            });
        });
    };
    // sende valid code an proxy und check ob sie zur Mobilnummer passt
    TextControl.prototype.makeSMSValidation = function (valueCode, valuePhoneNumber) {
        return __awaiter(this, void 0, Promise, function () {
            var apikey, checkValidCode, phoneCheck, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAPIKey()];
                    case 1:
                        apikey = _a.sent();
                        checkValidCode = useNotification({ apikey: apikey }).checkValidCode;
                        phoneCheck = null;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, checkValidCode(valuePhoneNumber, valueCode)];
                    case 3:
                        phoneCheck = _a.sent();
                        console.log('phoneCheck', phoneCheck);
                        if (phoneCheck)
                            return [2 /*return*/, phoneCheck];
                        return [3 /*break*/, 5];
                    case 4:
                        e_4 = _a.sent();
                        console.log(e_4);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/, null];
                }
            });
        });
    };
    TextControl.prototype.getAPIKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            var apikey, newAPIKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        apikey = this.$q.cookies.get('adserv');
                        if (!!apikey) return [3 /*break*/, 2];
                        return [4 /*yield*/, createAPIKey()];
                    case 1:
                        newAPIKey = _a.sent();
                        this.$q.cookies.set('adserv', newAPIKey, { expires: '1m' });
                        return [2 /*return*/, newAPIKey];
                    case 2: return [2 /*return*/, apikey];
                }
            });
        });
    };
    TextControl.prototype.updated = function () {
        if (this.isContinueAsOffer) {
            this.trInput.resetValidation();
        }
    };
    Object.defineProperty(TextControl.prototype, "isContinueAsOffer", {
        get: function () {
            return store.states.isContinueAsOffer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextControl.prototype, "inputType", {
        get: function () {
            if (hasInputMapping(this.input)) {
                return inputMapping[this.input];
            }
            return 'text';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextControl.prototype, "date", {
        get: function () {
            return this.baseInputProps.value;
        },
        set: function (value) {
            this.emitInput(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextControl.prototype, "isCheck", {
        get: function () {
            return this.props.isCheck;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextControl.prototype, "disabled", {
        get: function () {
            var _a;
            return (_a = this.props.disabled) !== null && _a !== void 0 ? _a : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextControl.prototype, "readonly", {
        get: function () {
            var _a;
            return (_a = this.props.readonly) !== null && _a !== void 0 ? _a : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextControl.prototype, "hasToolTip", {
        get: function () {
            var _a;
            return (_a = this.props.hasToolTip) !== null && _a !== void 0 ? _a : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextControl.prototype, "toolTip", {
        get: function () {
            var _a;
            return (_a = this.props.toolTip) !== null && _a !== void 0 ? _a : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextControl.prototype, "mask", {
        get: function () {
            var _a;
            return (_a = this.props.mask) !== null && _a !== void 0 ? _a : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextControl.prototype, "maxlength", {
        get: function () {
            var _a;
            return (_a = this.props.maxlength) !== null && _a !== void 0 ? _a : -1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextControl.prototype, "dateInput", {
        get: function () {
            return this.props.extends === 'date';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextControl.prototype, "multiInput", {
        get: function () {
            return this.props.extends === 'multi';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextControl.prototype, "validSMSCheckInput", {
        get: function () {
            return this.props.extends === 'validSMSCheck';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextControl.prototype, "validEMailCheckInput", {
        get: function () {
            return this.props.extends === 'validEMailCheck';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextControl.prototype, "maxMultiSelect", {
        get: function () {
            return store.states.maxMultiSelect;
        },
        enumerable: false,
        configurable: true
    });
    TextControl.prototype.handleBlur = function () {
        if (this.isContinueAsOffer) {
            this.trInput.resetValidation();
        }
    };
    TextControl.prototype.dateOptions = function (date) {
        return (date <=
            dayjs()
                .add(1, 'year')
                .format('YYYY/MM/DD'));
    };
    TextControl.prototype.emitCount = function (value) {
        this.countInputs = value;
        this.mapInputs();
        this.emitInput(this.controlProps.value);
        return value;
    };
    TextControl.prototype.mapInputs = function () {
        var seperator = ',';
        this.controlProps.value = this.inputValue1
            .concat(this.inputValue2 && this.countInputs > 1 ? seperator.concat(this.inputValue2) : '')
            .concat(this.inputValue3 && this.countInputs > 2 ? seperator.concat(this.inputValue3) : '')
            .concat(this.inputValue4 && this.countInputs > 3 ? seperator.concat(this.inputValue4) : '')
            .concat(this.inputValue5 && this.countInputs > 4 ? seperator.concat(this.inputValue5) : '')
            .concat(this.inputValue6 && this.countInputs > 5 ? seperator.concat(this.inputValue6) : '')
            .concat(this.inputValue7 && this.countInputs > 6 ? seperator.concat(this.inputValue7) : '')
            .concat(this.inputValue8 && this.countInputs > 7 ? seperator.concat(this.inputValue8) : '')
            .concat(this.inputValue9 && this.countInputs > 8 ? seperator.concat(this.inputValue9) : '')
            .concat(this.inputValue10 && this.countInputs > 9 ? seperator.concat(this.inputValue10) : '')
            .concat(this.inputValue11 && this.countInputs > 10 ? seperator.concat(this.inputValue11) : '')
            .concat(this.inputValue12 && this.countInputs > 11 ? seperator.concat(this.inputValue12) : '')
            .concat(this.inputValue13 && this.countInputs > 12 ? seperator.concat(this.inputValue13) : '')
            .concat(this.inputValue14 && this.countInputs > 13 ? seperator.concat(this.inputValue14) : '')
            .concat(this.inputValue15 && this.countInputs > 14 ? seperator.concat(this.inputValue15) : '')
            .concat(this.inputValue16 && this.countInputs > 15 ? seperator.concat(this.inputValue16) : '')
            .concat(this.inputValue17 && this.countInputs > 16 ? seperator.concat(this.inputValue17) : '')
            .concat(this.inputValue18 && this.countInputs > 17 ? seperator.concat(this.inputValue18) : '')
            .concat(this.inputValue19 && this.countInputs > 18 ? seperator.concat(this.inputValue19) : '');
    };
    TextControl.prototype.emitMulti1 = function (value) {
        this.inputValue1 = value;
        this.mapInputs();
        this.emitInput(this.controlProps.value);
        return value;
    };
    TextControl.prototype.emitMulti2 = function (value) {
        this.inputValue2 = value;
        this.mapInputs();
        this.emitInput(this.controlProps.value);
        return value;
    };
    TextControl.prototype.emitMulti3 = function (value) {
        this.inputValue3 = value;
        this.mapInputs();
        this.emitInput(this.controlProps.value);
        return value;
    };
    TextControl.prototype.emitMulti4 = function (value) {
        this.inputValue4 = value;
        this.mapInputs();
        this.emitInput(this.controlProps.value);
        return value;
    };
    TextControl.prototype.emitMulti5 = function (value) {
        this.inputValue5 = value;
        this.mapInputs();
        this.emitInput(this.controlProps.value);
        return value;
    };
    TextControl.prototype.emitMulti6 = function (value) {
        this.inputValue6 = value;
        this.mapInputs();
        this.emitInput(this.controlProps.value);
        return value;
    };
    TextControl.prototype.emitMulti7 = function (value) {
        this.inputValue7 = value;
        this.mapInputs();
        this.emitInput(this.controlProps.value);
        return value;
    };
    TextControl.prototype.emitMulti8 = function (value) {
        this.inputValue8 = value;
        this.mapInputs();
        this.emitInput(this.controlProps.value);
        return value;
    };
    TextControl.prototype.emitMulti9 = function (value) {
        this.inputValue9 = value;
        this.mapInputs();
        this.emitInput(this.controlProps.value);
        return value;
    };
    TextControl.prototype.emitMulti10 = function (value) {
        this.inputValue10 = value;
        this.mapInputs();
        this.emitInput(this.controlProps.value);
        return value;
    };
    TextControl.prototype.emitMulti11 = function (value) {
        this.inputValue11 = value;
        this.mapInputs();
        this.emitInput(this.controlProps.value);
        return value;
    };
    TextControl.prototype.emitMulti12 = function (value) {
        this.inputValue12 = value;
        this.mapInputs();
        this.emitInput(this.controlProps.value);
        return value;
    };
    TextControl.prototype.emitMulti13 = function (value) {
        this.inputValue13 = value;
        this.mapInputs();
        this.emitInput(this.controlProps.value);
        return value;
    };
    TextControl.prototype.emitMulti14 = function (value) {
        this.inputValue14 = value;
        this.mapInputs();
        this.emitInput(this.controlProps.value);
        return value;
    };
    TextControl.prototype.emitMulti15 = function (value) {
        this.inputValue15 = value;
        this.mapInputs();
        this.emitInput(this.controlProps.value);
        return value;
    };
    TextControl.prototype.emitMulti16 = function (value) {
        this.inputValue16 = value;
        this.mapInputs();
        this.emitInput(this.controlProps.value);
        return value;
    };
    TextControl.prototype.emitMulti17 = function (value) {
        this.inputValue17 = value;
        this.mapInputs();
        this.emitInput(this.controlProps.value);
        return value;
    };
    TextControl.prototype.emitMulti18 = function (value) {
        this.inputValue18 = value;
        this.mapInputs();
        this.emitInput(this.controlProps.value);
        return value;
    };
    TextControl.prototype.emitMulti19 = function (value) {
        this.inputValue19 = value;
        this.mapInputs();
        this.emitInput(this.controlProps.value);
        return value;
    };
    TextControl.prototype.emitMulti20 = function (value) {
        this.inputValue20 = value;
        this.mapInputs();
        this.emitInput(this.controlProps.value);
        return value;
    };
    TextControl.prototype.emitDate = function (value) {
        this.controlProps.value = value;
        this.inputValue = value;
        this.showDate = false;
    };
    Object.defineProperty(TextControl.prototype, "controlProps", {
        get: function () {
            var _a = this, baseInputProps = _a.baseInputProps, disabled = _a.disabled, inputType = _a.inputType, readonly = _a.readonly;
            if (this.isContinueAsOffer) {
                return {
                    label: baseInputProps.label.replace('*', ''),
                    value: baseInputProps.value,
                    name: baseInputProps.name,
                    outlined: baseInputProps.outlined,
                    square: baseInputProps.square,
                    maxlength: this.maxlength,
                    color: 'primary',
                    disable: disabled,
                    readonly: readonly,
                    type: inputType,
                    style: {
                        marginBottom: '20px'
                    },
                    mask: this.mask
                };
            }
            return __assign(__assign({}, baseInputProps), { color: 'primary', disable: disabled, type: inputType, maxlength: this.maxlength, readonly: readonly, mask: this.mask });
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ default: function () { return ({}); } })
    ], TextControl.prototype, "props", void 0);
    __decorate([
        Ref('tr-input')
    ], TextControl.prototype, "trInput", void 0);
    TextControl = __decorate([
        Component({
            components: { QInput: QInput, QIcon: QIcon, QDate: QDate, QBtn: QBtn, QSelect: QSelect }
        })
    ], TextControl);
    return TextControl;
}(BaseControl));
export default TextControl;
